import React, { forwardRef } from 'react';
import type { LinkProps as RouterLinkProps } from 'react-router';
import { Link as BrowserRouterLink } from 'react-router';
import { styled } from '@mui/material/styles';

import { omitUndefinedProps } from '@/mui/helpers';

type CustomLinkProps = Omit<RouterLinkProps, 'to'> & {
  to: string;
  replace?: boolean;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

const customProps: Array<keyof CustomLinkProps> = [];

const OverrideLink = styled(BrowserRouterLink, {
  shouldForwardProp: (prop) => !customProps.includes(prop as keyof CustomLinkProps),
})((/* { theme } */) => ({}));

const BrowserLink = forwardRef<HTMLAnchorElement, CustomLinkProps>((props, ref) => (
  <OverrideLink
    {...omitUndefinedProps(props)}
    to={props.to}
    ref={(node) => {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    }}
    onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      if (props.disabled) {
        event.stopPropagation();
      }
      if (props.onClick) {
        props.onClick(event);
      }
    }}
  />
));

BrowserLink.displayName = 'BrowserLink';

export default BrowserLink;
